// Web stand-in for react-native-onesignal, wired up in metro.config.js.
//
// v5.5.x calls TurboModuleRegistry.getEnforcing('OneSignal') AT IMPORT TIME, which
// throws on web and took the whole web bundle down with
// "Cannot read properties of undefined (reading 'getEnforcing')". (5.2.x read
// NativeModules.OneSignal, which was merely undefined, so this never surfaced
// before the SDK 57 upgrade.)
//
// Every app call site is already behind `if (!isWeb)` (see utils/onesignal/*), so
// these exports exist only to satisfy the imports - they are never invoked on web.
// The Proxy throws if that assumption is ever broken, instead of failing silently.

const explode = prop => {
  throw new Error(
    `react-native-onesignal is not available on web (attempted to use "${String(prop)}"). ` +
    'Guard the call site with isWeb.',
  );
};

const inert = name =>
  new Proxy({}, { get: (_t, prop) => (prop === '__esModule' ? undefined : explode(`${name}.${String(prop)}`)) });

export const OneSignal = inert('OneSignal');

// Enum-like: reading members must NOT throw (used in expressions before guards).
export const LogLevel = {
  None: 0, Fatal: 1, Error: 2, Warn: 3, Info: 4, Debug: 5, Verbose: 6,
};

export default { OneSignal, LogLevel };
